import {
  HTTP_STEP_UP_REQUIRED,
  isHandledError,
  useQueryClient,
  useSecurityDialog,
} from "@pharmupp/p3-front-commons"
import { useNavigate } from "react-router-dom"

export const useQuerySecurityHandler = () => {
  const client = useQueryClient()
  const securityDialog = useSecurityDialog()
  const navigate = useNavigate()

  const goHome = () => {
    navigate("/")
    securityDialog.closeDialog()
  }

  client.getQueryCache().subscribe(async (event) => {
    if (event.type === "observerResultsUpdated" && event.query.state.error) {
      const { error } = event.query.state
      if (isHandledError(error) && error.statusCode === HTTP_STEP_UP_REQUIRED) {
        securityDialog.loadingDialog({
          goHome,
        })
      }
    }
  })

  client.getMutationCache().subscribe(async (event) => {
    if (event.type === "updated") {
      const { error } = event.mutation.state
      if (isHandledError(error) && error.statusCode === HTTP_STEP_UP_REQUIRED) {
        securityDialog.loadingDialog({ goHome })
      }
    }
  })
}
